import { Box, Tab, Tabs } from '@mui/material';
import MenuInfo from 'data/menu';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

function LinkTab(props) {
    const {href, ...restProps} = props;
    let navigate = useNavigate();
    return (
        <Tab
            sx={{
                fontWeight: "bold", fontSize: "16px", backgroundColor: "#c1c1c1", borderRadius: "unset", color: "#fff", border: "unset",
                "&.Mui-selected" : {backgroundColor: "#177ddc",borderRadius: "unset", color: "#fff"},
            }}
            onClick={() => { navigate(href); }}
            {...restProps}
        />
    );
}

export default function MonitoringSettingTabsLayout(props) {
    const { menuId } = props;
    const tabs = MenuInfo.ROOT.find(menuId);
    const fullpath = useLocation().pathname;
    return (
        <>
        <div className="mobile_navi" style={{color:"#000"}}>
        {
            ((tabs.children.find((child) => child.isActive).fullpath === fullpath) ? tabs.children.find((child) => child.isActive).element.props.comment : "")
        }
        </div>

        {(tabs.children && tabs.children.length > 1) ?
        <>
        <Box sx={{ width: '100%', "& .MuiBox-root": {borderColor:"rgba(255, 255, 255, 0.05)"} }} className="mrosetup_tabs">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabs.activeChildIndex()} aria-label="basic tabs example">
                    {
                        tabs.children.map(child => {
                            return (<LinkTab key={child.id} label={child.name} href={child.fullpath}/>)
                        })
                    }
                </Tabs>
            </Box>
        </Box>
        <Outlet/>
        </>
        :
        <Outlet/>
        }
        </>
    )
}